import React, { Component } from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { Grid, Theme, Typography } from "@material-ui/core";
import cx from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    borderBottom: {
      borderBottom: 'solid 3px #333'
    },
    activeTab: {
      // fontWeight: 600,
      // color: "#333!important",
      // position: "relative",
    },
    customCss:{
      fontWeight: 600,
      color: "#1d7dea !important",
      borderBottom:'solid 4px #1d7dea',
      '&:hover':{
        color: "#1d7dea !important",
      }
    },
    paddingMedium:{
      padding:'7px 10px 4px',
    },
    tabs: {
      fontSize: 18,
      lineHeight: "28px",
      color: "#333",
      marginRight: "30px!important",
      cursor: "pointer",
      '&:hover': {
        color: "#333!important",
        position: "relative"
      }
    },
    color:{
      '&:hover':{
        color: '#1d7dea !important'
      }
    }
  });

interface Props extends WithStyles<typeof styles> {
  eventKey: string;
  setActiveTab?: (expanded: boolean) => void;
  activeTab?: string;
  defaultValue?: boolean;
  onClick?: Function;
  isCustomCSS?:boolean,
  fontWeight?:any,
  color?:'',
  customColor?:'',
  borderBottom?:'',
  renderer?: (eventKey: string, isActive?: boolean) => any
}
class MyPATTab extends Component<Props> {
  
  defaultRenderer = (eventKey: string) => {
    return eventKey
  }

  setActiveTab(eventKey: any) {
    if (this.props.setActiveTab) {
      this.props.setActiveTab(eventKey);
    }
    if (this.props.onClick) {
      this.props.onClick(eventKey);
    }
  }
  render() {
    const { classes, eventKey, activeTab, defaultValue,isCustomCSS=false,color='#333', borderBottom,fontWeight=600,customColor='#333!important', renderer = this.defaultRenderer } = this.props;
    const isActive = activeTab ? (activeTab === eventKey) : defaultValue;
    return (
      <>
      
        <Grid container>
          <p
            className={cx(classes.tabs,isCustomCSS && classes.paddingMedium, isActive && isCustomCSS && classes.borderBottom)}
            //isActive? classes.activeTab: isCustomCSS?classes.customCss:'',
            onClick={() => {
              this.setActiveTab(eventKey);
            }}
            style={{ fontWeight: isActive && fontWeight,
              color: isActive && isCustomCSS?customColor:'',
              borderBottom:isActive && isCustomCSS?borderBottom:'', position: "relative"}}
          >
            {renderer(eventKey, isActive)}
          </p>
        </Grid>
        
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATTab);
